module.exports = __webpack_public_path__ + "static/img/ryoji-iwata-vWfKaO0k9pc-unsplash_thumb.caf3c2a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/ryoji-iwata-vWfKaO0k9pc-unsplash_thumb.png
// module id = 10ko
// module chunks = 4